module.exports = __webpack_public_path__ + "static/media/computer.c782405d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/computer.png
// module id = 527
// module chunks = 43